// Highcharts (npm) bootstrap for the Vite bundle.
//
// MyAccount's chart code lives in Sprockets-era global scripts
// (app/assets/javascripts/src/*.js) that reference a global `window.Highcharts`
// (e.g. Highcharts.chart, Highcharts.stockChart, drilldown). Previously
// Highcharts was vendored as static files. We now load it from the npm package
// (highcharts@13.1.1, the security-patched release) and expose it on `window`
// so the existing global chart code keeps working unchanged.
//
// Notes on the v13 module system:
//   - `highcharts/highstock` is the Stock bundle and already includes
//     Highcharts core, so we must NOT also import `highcharts` separately
//     (that would load core twice and trigger a "already defined" warning).
//   - Since Highcharts v11+, feature modules self-register on import. They are
//     imported purely for their side effects — do NOT call them as functions
//     (the old `Drilldown(Highcharts)` pattern was removed and now throws).

import Highcharts from "highcharts/highstock";
import "highcharts/modules/drilldown";

// Expose globally for the Sprockets chart scripts. The Vite bundle runs before
// `$(document).ready`, where initializeHighcharts() and the per-page chart
// functions execute, so the global is in place in time.
window.Highcharts = Highcharts;

export default Highcharts;
